import { useMemo } from 'react';
import Favicon from 'react-favicon';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import { isEmpty } from 'lodash';
import { RootState } from '@share/utils';
import { ILoginState } from '@share/store/slices';

import FaviconImage from '@assets/images/favicon.png';

interface IMapStateToProps {
  loginStore: ILoginState;
}

interface IProps extends IMapStateToProps, RouteComponentProps {}

function ApplicationHelmetComponent(props: IProps) {
  const { loginStore } = props;
  const { account } = loginStore;
  
  const faviconPref = account?.faviconPref;
  const pageTitlePref = account?.pageTitlePref;

  const favicon = useMemo(() => !isEmpty(faviconPref) ? faviconPref : FaviconImage, [faviconPref]);

  return (
    <>
      <Favicon url={favicon as string} />
      
      <Helmet>
        {!isEmpty(pageTitlePref) ? (
          <title>{pageTitlePref}</title>) : null}
      </Helmet>
    </>);
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
  };
};

const ApplicationComponentWithRouter = withRouter(ApplicationHelmetComponent);

export const ApplicationHelmet = connect(mapStateToProps)(ApplicationComponentWithRouter);
